{
  "salon-details-header": {
    "buttons": {
      "link-copied": "LIEN COPIÉ",
      "share": "PARTAGER",
      "visit-virtually": "VISITER VIRTUELLEMENT LE SALON"
    }
  }
}
